interface UserStaffToTeam {
  userStaffToTeamId: string;
  teamId: string;
  userStaffId: string;
}

export const filterUserStaffToTeam = (
  allUserStaffToTeam: UserStaffToTeam[],
  excludedIds: string[] = [],
): UserStaffToTeam[] => {
  return allUserStaffToTeam
    .filter((item) => !Array.isArray(excludedIds) || !excludedIds.includes(item.userStaffToTeamId))
    .map((item) => ({
      userStaffToTeamId: item.userStaffToTeamId,
      teamId: item.teamId,
      userStaffId: item.userStaffId,
    }));
};
